import { render } from "./Reinsurance.vue?vue&type=template&id=2b289f00&scoped=true"
import script from "./Reinsurance.vue?vue&type=script&lang=js"
export * from "./Reinsurance.vue?vue&type=script&lang=js"

import "./Reinsurance.vue?vue&type=style&index=0&id=2b289f00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b289f00"]])

export default __exports__